import type { managePilots as en } from '@/i18n/locales/en/managePilots';
import type { Translation } from '@/i18n/types';

export const managePilots: Translation<typeof en> = {
  page: {
    title: 'Πιλοτικά',
    lead: 'Όλα τα πιλοτικά προγράμματα στην πλατφόρμα, φιλτραρισμένα ανά εταιρεία και κατάσταση.',
    filterCompany: 'Εταιρεία',
    filterStatus: 'Κατάσταση',
    allCompanies: 'Όλες οι εταιρείες',
    allStatuses: 'Όλες οι καταστάσεις',
    empty: 'Κανένα πιλοτικό δεν ταιριάζει με αυτά τα φίλτρα.',
    rowsLabel: 'τα πιλοτικά',
    company: 'Εταιρεία',
    name: 'Όνομα',
    status: 'Κατάσταση',
    startDate: 'Ημερομηνία έναρξης',
    endDate: 'Ημερομηνία λήξης',
    departments: 'Τμήματα',
  },
  status: {
    draft: 'Πρόχειρο',
    baseline: 'Αρχική μέτρηση',
    active: 'Ενεργό',
    interim_review: 'Ενδιάμεση αξιολόγηση',
    final_review: 'Τελική αξιολόγηση',
    completed: 'Ολοκληρώθηκε',
    scaled: 'Σε κλιμάκωση',
  },
};
